import 'core-js/stable'
import 'regenerator-runtime/runtime'
import { Provider } from 'react-redux'
import { Route, Switch, Redirect, Router } from 'react-router-dom'
import store from './store/configureStore'
import App from './components/App'
import PrivateRoute from './components/routes/PrivateRoute'
import { LoginPage, ModalContainer } from './containers'
import { AthenaGlobalHeader, AthenaGlobalFooter } from './components/common'
import { NAV_LINKS } from './constants/NavConstants'
import history from './utils/history'

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <div>
        <AthenaGlobalHeader />
        <Switch>
          <Redirect from="/" exact to={NAV_LINKS.login} />
          <Route path={NAV_LINKS.login} component={LoginPage} />
          <PrivateRoute component={App} />
        </Switch>
        <ModalContainer />
        <AthenaGlobalFooter />
      </div>
    </Router>
  </Provider>,
  document.getElementById('root')
)
